<template>
  <b-col
    lg="4"
    md="6"
    cols="12"
  >
    <b-card>
      <b-overlay
        :show="loadingEarnCashback"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity="0.3"
      >
        <div class="h-[13rem] md:h-[14rem]">
          <div class="d-flex justify-content-between">
            <div v-if="page === 1">
              <span class="k-receipt-disscount text-xl text-[#34A770] bg-[#DCF3EB] p-[5px] rounded" />
              <span class="text-xl font-semibold">
                Penghematan Ongkir
              </span>
              <span
                v-b-tooltip.hover
                title="Total cashback yang kamu dapatkan semenjak menggunakan komship"
                class="k-info-circle-1 text-[#08A0F7] text-xl"
              />
              <p class="text-3xl font-semibold">
                Rp {{ cashback.toLocaleString('id-ID') }}
              </p>
            </div>
            <div
              v-else
              class="w-100"
            >
              <div class="d-flex justify-content-between">
                <div>
                  <span class="text-xl font-semibold">
                    Hemat Ongkir
                  </span>
                  <p class="text-3xl font-semibold mb-0">
                    Rp {{ earnState.total_earn_cashback_monthly.toLocaleString('id-ID') }}</p>
                </div>
                <div class="w-[100px] mb-auto mr-1">
                  <flat-pickr
                    v-model="filterDateCashback"
                    :config="flatpickrMonthly"
                    class="form-control"
                    @input="updateEarnCashback()"
                  />
                </div>
              </div>
              <!-- <span class="text-lg mb-0">
                Ongkir Retur (Berangkat)
              </span>
              <p class="text-lg font-semibold mb-0">
                Rp {{ earnState.total_benefit_retur_monthly.toLocaleString('id-ID') }}
              </p> -->
            </div>
            <div>
              <b-button
                variant="outline-secondary"
                class="btn-icon rounded-lg p-0"
                size="sm"
                :disabled="page === 1"
                @click="page = 1"
              >
                <feather-icon
                  icon="ChevronUpIcon"
                  size="25"
                />
              </b-button><br>
              <b-button
                variant="outline-secondary"
                class="btn-icon rounded-lg p-0 mt-[6px]"
                size="sm"
                :disabled="page === 2"
                @click="page = 2"
              >
                <feather-icon
                  icon="ChevronDownIcon"
                  size="25"
                />
              </b-button>
            </div>
          </div>
          <div class="my-1 border-t-2" />
          <div class="d-flex justify-content-between">
            <div>
              <span class="k-money-add text-xl text-[#D19D04] bg-[#FFF2E2] p-[5px] rounded" />
              <span class="text-xl font-semibold">
                Saldo Pending
              </span>
              <span
                v-b-tooltip.hover
                title="Saldo Pending merupakan saldo yang akan kamu terima ketika orderan yang statusnya dikirim telah berubah menjadi diterima."
                class="k-info-circle-1 text-[#08A0F7] text-xl"
              />
              <p class="text-3xl font-semibold">
                Rp {{ saldoPending.toLocaleString('id-ID') }}
              </p>
              <span class="mb-0 text-gray-600 text-sm">
                Dari nilai tersebut, <span class="text-primary">Rp {{ saldoPendingOnProblem.toLocaleString('id-ID') }},-</span> nya perlu dimonitor
              </span>
            </div>
            <div>
              <b-button
                variant="outline-secondary"
                class="rounded-lg p-0"
                size="sm"
                :to="{ name: $route.meta.routeToOrder, query: { tab: 'dikirim' } }"
              >
                <feather-icon
                  icon="ChevronRightIcon"
                  size="25"
                />
              </b-button>
            </div>
          </div>
        </div>
      </b-overlay>
    </b-card>
  </b-col>
</template>
<script>
import { mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import MonthSelect from 'flatpickr/dist/plugins/monthSelect'
import '@/@core/scss/vue/libs/vue-flatpicker.scss'
import 'flatpickr/dist/plugins/monthSelect/style.css'

export default {
  components: { flatPickr },
  data() {
    return {
      page: 1,
      filterDateCashback: moment().format('YYYY-MM-DD'),
      flatpickrMonthly: {
        mode: 'single',
        locale: Indonesian,
        altInput: true,
        altFormat: 'j/n/Y',
        dateFormat: 'Y-m-d',
        maxDate: 'today',
        disableMobile: true,
        plugins: [
          new MonthSelect({
            shorthand: true,
            dateFormat: 'Y-m-d',
            altFormat: 'F Y',
          }),
        ],
      },
    }
  },
  computed: {
    ...mapState('dashboard', [
      'cashback',
      'earnState',
      'saldoPending',
      'saldoPendingOnProblem',
      'loadingEarnCashback',
    ]),
    ...mapFields('dashboard', [
      'earnStartDate',
      'earnEndDate',
    ]),
  },
  mounted() {
    this.updateEarnCashback()
  },
  methods: {
    async updateEarnCashback() {
      const startDate = moment(this.filterDateCashback).startOf('month').format('YYYY-MM-DD')
      const endDate = moment(this.filterDateCashback).endOf('month').format('YYYY-MM-DD')
      this.earnStartDate = startDate
      this.earnEndDate = endDate
      await this.$store.dispatch('dashboard/fetchEarnCashback')
    },
  },
}
</script>
<style>
.flatpickr-monthSelect-month.selected{
  background-color: #F95031 !important;
}
</style>
